var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 387,
    height: 396
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lines_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 189",
    fill: "#fff",
    stroke: "#690",
    strokeWidth: 0.5,
    d: "M8068 2942h387v396h-387z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 33",
    transform: "translate(-8068 -2942)",
    clipPath: "url(#lines_svg__a)",
    fill: "none",
    stroke: "#690"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 895",
    d: "M8348.812 2357.226l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 896",
    d: "M8354.446 2360.349l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 897",
    d: "M8360.082 2363.473l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 898",
    d: "M8365.717 2366.596l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 899",
    d: "M8371.352 2369.72l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 900",
    d: "M8376.986 2372.844l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 901",
    d: "M8382.621 2375.967l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 902",
    d: "M8388.256 2379.091l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 903",
    d: "M8393.891 2382.214l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 904",
    d: "M8399.526 2385.338l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 905",
    d: "M8405.161 2388.461l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 906",
    d: "M8410.797 2391.585l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 907",
    d: "M8416.432 2394.708l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 908",
    d: "M8422.066 2397.832l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 909",
    d: "M8427.701 2400.955l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 910",
    d: "M8433.336 2404.079l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 911",
    d: "M8438.971 2407.202l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 912",
    d: "M8444.605 2410.326l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 913",
    d: "M8450.241 2413.449l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 914",
    d: "M8455.876 2416.573l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 915",
    d: "M8461.512 2419.696l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 916",
    d: "M8467.146 2422.82l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 917",
    d: "M8472.781 2425.943L7925.503 3413.3",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 918",
    d: "M8478.416 2429.067l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 919",
    d: "M8484.051 2432.19l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 920",
    d: "M8489.686 2435.314l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 921",
    d: "M8495.32 2438.438l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 922",
    d: "M8500.956 2441.561l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 923",
    d: "M8506.591 2444.685l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 924",
    d: "M8512.227 2447.808l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 925",
    d: "M8517.861 2450.932l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 926",
    d: "M8523.496 2454.055l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 927",
    d: "M8529.131 2457.178l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 928",
    d: "M8534.766 2460.302l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 929",
    d: "M8540.4 2463.426l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 930",
    d: "M8546.036 2466.549l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 931",
    d: "M8551.671 2469.673l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 932",
    d: "M8557.306 2472.796l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 933",
    d: "M8562.941 2475.92l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 934",
    d: "M8568.576 2479.043L8021.298 3466.4",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 935",
    d: "M8574.211 2482.167l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 936",
    d: "M8579.846 2485.291l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 937",
    d: "M8585.48 2488.414l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 938",
    d: "M8591.115 2491.538l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 939",
    d: "M8596.751 2494.661l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 940",
    d: "M8602.386 2497.784l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 941",
    d: "M8608.021 2500.908l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 942",
    d: "M8613.656 2504.031l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 943",
    d: "M8619.291 2507.155l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 944",
    d: "M8624.926 2510.279l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 945",
    d: "M8630.561 2513.402l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 946",
    d: "M8636.195 2516.526l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 947",
    d: "M8641.83 2519.649l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 948",
    d: "M8647.466 2522.773l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 949",
    d: "M8653.101 2525.896l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 950",
    d: "M8658.736 2529.02l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 951",
    d: "M8664.371 2532.143L8117.093 3519.5",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 952",
    d: "M8670.006 2535.267l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 953",
    d: "M8675.641 2538.39l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 954",
    d: "M8681.275 2541.514l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 955",
    d: "M8686.91 2544.637l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 956",
    d: "M8692.545 2547.761l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 957",
    d: "M8698.181 2550.884l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 958",
    d: "M8703.815 2554.008l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 959",
    d: "M8709.451 2557.131l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 960",
    d: "M8715.086 2560.255l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 961",
    d: "M8720.721 2563.378l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 962",
    d: "M8726.355 2566.502l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 963",
    d: "M8731.99 2569.625l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 964",
    d: "M8737.625 2572.749l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 965",
    d: "M8743.26 2575.873l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 966",
    d: "M8748.896 2578.996l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 967",
    d: "M8754.53 2582.12l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 968",
    d: "M8760.166 2585.243L8212.888 3572.6",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 969",
    d: "M8765.801 2588.367l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 970",
    d: "M8771.436 2591.49l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 971",
    d: "M8777.07 2594.614l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 972",
    d: "M8782.705 2597.737l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 973",
    d: "M8788.341 2600.861l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 974",
    d: "M8793.975 2603.984l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 975",
    d: "M8799.61 2607.108l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 976",
    d: "M8805.245 2610.231l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 977",
    d: "M8810.881 2613.355l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 978",
    d: "M8816.516 2616.479l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 979",
    d: "M8822.15 2619.602l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 980",
    d: "M8827.785 2622.726l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 981",
    d: "M8833.42 2625.849l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 982",
    d: "M8839.056 2628.972l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 983",
    d: "M8844.69 2632.096l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 984",
    d: "M8850.325 2635.22l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 985",
    d: "M8855.96 2638.343L8308.682 3625.7",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 986",
    d: "M8861.596 2641.466l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 987",
    d: "M8867.23 2644.59l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 988",
    d: "M8872.865 2647.714l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 989",
    d: "M8878.5 2650.837l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 990",
    d: "M8884.135 2653.96l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 991",
    d: "M8889.77 2657.084l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 992",
    d: "M8895.405 2660.208l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 993",
    d: "M8901.041 2663.332l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 994",
    d: "M8906.676 2666.455l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 995",
    d: "M8912.779 2666.455l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 996",
    d: "M8918.414 2669.578l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 997",
    d: "M8924.051 2672.702l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 998",
    d: "M8929.686 2675.825l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 999",
    d: "M8935.32 2678.949l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1000",
    d: "M8940.955 2682.072l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1001",
    d: "M8946.59 2685.196l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1002",
    d: "M8952.225 2688.319l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1003",
    d: "M8957.859 2691.443L8410.581 3678.8",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1004",
    d: "M8963.494 2694.566l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1005",
    d: "M8969.129 2697.69l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1006",
    d: "M8974.766 2700.813l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1007",
    d: "M8980.4 2703.937l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1008",
    d: "M8986.035 2707.06l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1009",
    d: "M8991.67 2710.184l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1010",
    d: "M8997.305 2713.307l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1011",
    d: "M9002.939 2716.431l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1012",
    d: "M9008.574 2719.554l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1013",
    d: "M9014.209 2722.678l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1014",
    d: "M9019.844 2725.801l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1015",
    d: "M9025.48 2728.925l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1016",
    d: "M9031.115 2732.048l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1017",
    d: "M9036.75 2735.172l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1018",
    d: "M9042.385 2738.295l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1019",
    d: "M9048.02 2741.419l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1020",
    d: "M9053.654 2744.542l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1021",
    d: "M9059.289 2747.666l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1022",
    d: "M9064.924 2750.79l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1023",
    d: "M9070.559 2753.913l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1024",
    d: "M9076.195 2757.037l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1025",
    d: "M9081.83 2760.16l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1026",
    d: "M9087.465 2763.284l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1027",
    d: "M9093.1 2766.407l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1028",
    d: "M9098.734 2769.531l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1029",
    d: "M9104.369 2772.654l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1030",
    d: "M9110.004 2775.778l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1031",
    d: "M9115.639 2778.901l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1032",
    d: "M9121.273 2782.025l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1033",
    d: "M9126.91 2785.148l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1034",
    d: "M9132.545 2788.272l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1035",
    d: "M9138.18 2791.395l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1036",
    d: "M9143.814 2794.519l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1037",
    d: "M9149.449 2797.642l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1038",
    d: "M9155.084 2800.766l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1039",
    d: "M9160.719 2803.889l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1040",
    d: "M9166.354 2807.013l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1041",
    d: "M9171.99 2810.136l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1042",
    d: "M9177.625 2813.26l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1043",
    d: "M9183.26 2816.384l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1044",
    d: "M9188.895 2819.507l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1045",
    d: "M9194.529 2822.631l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1046",
    d: "M9200.164 2825.754l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1047",
    d: "M9205.799 2828.878l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1048",
    d: "M9211.434 2832.001l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1049",
    d: "M9217.068 2835.125l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1050",
    d: "M9222.705 2838.248l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1051",
    d: "M9228.34 2841.372l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1052",
    d: "M9233.975 2844.495l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1053",
    d: "M9239.609 2847.619l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1054",
    d: "M9245.244 2850.742l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1055",
    d: "M9250.879 2853.866l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1056",
    d: "M9256.514 2856.99l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1057",
    d: "M9262.148 2860.113L8714.87 3847.47",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1058",
    d: "M9267.783 2863.236l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1059",
    d: "M9273.42 2866.36l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1060",
    d: "M9279.055 2869.483l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1061",
    d: "M9284.689 2872.607l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1062",
    d: "M9290.324 2875.73l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1063",
    d: "M9295.959 2878.854l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1064",
    d: "M9301.594 2881.978l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1065",
    d: "M9307.229 2885.102l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1066",
    d: "M9312.863 2888.225l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1067",
    d: "M9318.498 2891.348l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1068",
    d: "M9324.135 2894.472l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1069",
    d: "M9329.77 2897.595l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1070",
    d: "M9335.404 2900.719l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1071",
    d: "M9341.039 2903.842l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1072",
    d: "M9346.674 2906.966l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1073",
    d: "M9352.309 2910.089l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1074",
    d: "M9357.943 2913.213l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1075",
    d: "M9363.578 2916.336L8816.3 3903.693",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1076",
    d: "M9369.213 2919.46l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1077",
    d: "M9374.85 2922.583l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1078",
    d: "M9380.484 2925.707l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1079",
    d: "M9386.119 2928.831l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1080",
    d: "M9391.754 2931.954l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1081",
    d: "M9397.389 2935.078l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1082",
    d: "M9403.023 2938.201l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1083",
    d: "M9408.658 2941.325l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1084",
    d: "M9414.293 2944.448l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1085",
    d: "M9419.928 2947.572l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1086",
    d: "M9425.564 2950.695l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1087",
    d: "M9431.199 2953.819l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1088",
    d: "M9436.834 2956.942l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1089",
    d: "M9442.469 2960.066l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1090",
    d: "M9448.104 2963.189l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1091",
    d: "M9453.738 2966.313L8906.46 3953.67",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1092",
    d: "M9459.373 2969.437l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1093",
    d: "M9465.01 2972.56l-547.278 987.357",
    strokeWidth: 1.00042
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1094",
    d: "M9470.645 2975.683l-547.278 987.357",
    strokeWidth: 1.00042
  }))));
}

export default __webpack_public_path__ + "4bc3709b74ad8bc6329b9f1e1ce38a16.svg";
export { SvgLines as ReactComponent };